import { Container } from "inversify";
import getDecorators from "inversify-inject-decorators";
import { PrimariaApi } from "@uxland/primary-shell";
import { TYPES } from "./types";
import { store } from "../state/store";
const container = new Container();
const { lazyInject } = getDecorators(container, false);

export { container, lazyInject };

export const bindDeps = (api: PrimariaApi) => {
  container.bind(TYPES.primaryApi).toConstantValue(api);
  container.bind(TYPES.store).toConstantValue(store);
};

export const unbindDeps = () => {
  container.unbind(TYPES.primaryApi);
  container.unbind(TYPES.store);
};
